
<div class="edit-page-root-container area-manager-component-container">
    <div class="page-content">
        <!-- Page Header -->
        <div class="page-header">
            <div class="page-title">
                <img class="icon" src="assets/images/menu/svg/area-manager.svg" width="30" height="30">
                <span class="title">Area Manager Shop</span>
            </div>

            <!-- Action Buttons -->
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" 
                        [disabled]="isLoading"
                        (click)="exportClicked()">
                    EXPORT
                </button>
                <button mat-flat-button class="action-btn btn-save" 
                        [disabled]="isLoading || !selectedAreaManagerId"
                        (click)="saveChanges()">
                    SAVE
                </button>
            </div>
        </div>

        <!-- Page Details -->
        <div class="page-details">
            <div class="detail-section">
                <div class="content-container">
                    <!-- Loading Overlay -->
                    <!-- <div class="loading-overlay" *ngIf="isLoading">
                        <div class="loader-container">
                            <app-loader [show]="true"></app-loader>
                        </div>
                    </div> -->
                    
                    <!-- Area Manager Selection -->
                    <div class="dropdown-container">
                        <mat-form-field appearance="fill">
                            <mat-label>Select Area Manager</mat-label>
                            <input type="text" placeholder="Select Area Manager" aria-label="Area Manager" matInput
                                [formControl]="areaManagerControl" [matAutocomplete]="auto"
                                [disabled]="isLoading">

                            <!-- Clear button -->
                            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearAreaManager()"
                                *ngIf="areaManagerControl.value && !isLoading">
                                <mat-icon>close</mat-icon>
                            </button>

                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayManagerName"
                                (optionSelected)="onAreaManagerSelected($event)">
                                <mat-option *ngFor="let manager of filteredManagers | async" [value]="manager">
                                    {{ manager.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>

                    <!-- Shop Assignment Table -->
                    <div class="table-container">
                        <app-loader [show]="isLoading"></app-loader>
                        
                        <table class="area-manager-table" *ngIf="areaManagerShopList.length > 0 && !isLoading">
                            <!-- Table Header -->
                            <thead>
                                <tr>
                                    <th class="serial-column">Sl</th>
                                    <th class="name-column">Shop Name</th>
                                    <th class="checkbox-column">
                                        Assign Shop
                                    </th>
                                    <th class="checkbox-column">
                                        Allow Login
                                    </th>
                                </tr>
                            </thead>
                            
                            <!-- Table Body -->
                            <tbody>
                                <!-- Shop Items -->
                                <tr class="shop-item-row" 
                                    *ngFor="let shop of areaManagerShopList; let i = index">
                                    <td class="serial-cell">{{ i + 1 }}</td>
                                    <td class="name-cell" [title]="shop.name">{{ shop.name }}</td>
                                    <td class="checkbox-cell">
                                        <mat-checkbox 
                                            [checked]="!!shop.assign_shop"
                                            (change)="onAssignShopChange(shop, $event.checked)"
                                            [disabled]="!selectedAreaManagerId || isLoading">
                                        </mat-checkbox>
                                    </td>
                                    <td class="checkbox-cell">
                                        <mat-checkbox 
                                            [checked]="!!shop.allow_login"
                                            (change)="onAllowLoginChange(shop, $event.checked)"
                                            [disabled]="!selectedAreaManagerId || !shop.assign_shop || isLoading">
                                        </mat-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- No Data Message -->
                        <div *ngIf="areaManagerShopList.length === 0 && !isLoading" class="no-data">
                            <mat-icon style="font-size: 48px; color: #ccc;">info</mat-icon>
                            <p *ngIf="selectedAreaManagerId">No shops found for the selected Area Manager.</p>
                            <p *ngIf="!selectedAreaManagerId">Please select an Area Manager to assign shops.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>